window.flow = window.flow || {};

Object.assign(window.flow, {
  initYotpoProductCardRatings: function(root) {
    var scope = root || document;
    var widgets = [];

    if (scope.nodeType === 1 && scope.matches('[data-flow-yotpo-card-rating]')) {
      widgets.push(scope);
    }

    widgets = widgets.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-flow-yotpo-card-rating]')));

    widgets.forEach(function(widget) {
      if (widget.dataset.flowYotpoCardRatingInitialized === 'true') {
        flow.updateYotpoProductCardRating(widget);
        return;
      }

      flow.updateYotpoProductCardRating(widget);

      new MutationObserver(function() {
        flow.updateYotpoProductCardRating(widget);
      }).observe(widget, {
        childList: true,
        subtree: true,
        characterData: true
      });

      widget.dataset.flowYotpoCardRatingInitialized = 'true';
    });
  },
  updateYotpoProductCardRating: function(widget) {
    var score = this.getYotpoProductCardRatingScore(widget);

    if (score === null) {
      widget.classList.add('hide');
      return;
    }

    widget.classList.toggle('hide', score === 0);
  },
  getYotpoProductCardRatingScore: function(widget) {
    var scoreElement = widget && (
      widget.querySelector('.yotpo-sr-bottom-line-score') ||
      widget.querySelector('[class*="bottom-line-score"]')
    );
    var scoreText;
    var scoreMatch;

    if (!scoreElement) {
      return null;
    }

    scoreText = scoreElement.textContent.trim();
    scoreMatch = scoreText.match(/\d+(?:\.\d+)?/);

    if (!scoreMatch) {
      return null;
    }

    return parseFloat(scoreMatch[0]);
  }
});

document.addEventListener('DOMContentLoaded', function() {
  flow.initYotpoProductCardRatings();

  new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      Array.prototype.forEach.call(mutation.addedNodes, function(node) {
        if (node.nodeType === 1) {
          flow.initYotpoProductCardRatings(node);
        }
      });
    });
  }).observe(document.body, {
    childList: true,
    subtree: true
  });
});
